import { useBusinessEngineApi } from 'infrastructure/api';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import UPDATE_PROCESS_VARIABLES_VALIDATION from 'domain/gpo/cockpit/instance/Show/variables/shared/ProcessVariableValidation';
import { BOOLEAN_VALUE, VARIABLE_OBJECT_TYPES, VARIABLE_TYPES } from 'domain/gpo/cockpit/instance/Show/variables/types';

export const UPDATE_PROCESS_VARIABLES_LIST = 'UPDATE_VARIABLES_LIST';

const useProcessVariableService = () => {
  const processInstanceId = useProcessInstanceId();
  const { sendPostRequest } = useBusinessEngineApi();

  const create = async (request: any) => {
    const mappedRequest = { ...request };
    if (request.type === VARIABLE_TYPES.OBJECT) {
      mappedRequest.value =
        request.objectTypeName === VARIABLE_OBJECT_TYPES.OTHER ? JSON.parse(request.value) : request.value;
    } else {
      mappedRequest.objectTypeName = null;
      mappedRequest.value =
        request.type === VARIABLE_TYPES.BOOLEAN ? request.value === BOOLEAN_VALUE.TRUE : request.value;
    }
    const response = await sendPostRequest(`/camunda/processes/${processInstanceId}/variables/create`, mappedRequest);
    return response;
  };

  const getValidationSchema = () => Promise.resolve(UPDATE_PROCESS_VARIABLES_VALIDATION);

  return {
    create,
    getValidationSchema,
  };
};

export default useProcessVariableService;
